import { toast } from "@/ui-plus/sonner";

export const killApp = async function () {
    if (typeof global === "undefined") {
        toast.info('simulating kill app');
        return;
    }
    if (import.meta.env.DEV || prompt("please enter '123' to close the app") === "123") {
        if (typeof global !== "undefined") {
            require('nw.gui').App.quit();
        }
    } else {
        toast.error("wrong password");
    }
}